import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { ApiHttpService } from './api-http.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  isCfStraniero$ = new BehaviorSubject(false);
  isIndirizzoEstero$ = new BehaviorSubject(false);
  _isCfStraniero$ = this.isCfStraniero$.asObservable();

  _cerved_approved?: boolean | undefined;
  get cerved_approved() {
    return this._cerved_approved;
  }
  set cerved_approved(v) {
    this._cerved_approved = v;
  }

  _results_cerved: any;
  get results_cerved() {
    return this._results_cerved;
  }
  set results_cerved(v) {
    this._results_cerved = v;
  }

  volume_cerved?: number;


  prodotto?: {
    cod_tipo_fornitura_id: string;
    codice_prodotto: string;
    des_fattura: string;
    des_prodotto: string;
    energia_verde: number;
    id_prodotto: number;
    note: string | null;
    stato: number;
    utilizzo: string;
    tipo_utenza: string;
    natura: string;
    aumix?: string;
  };
  cliente_pdp?: { [x: string]: any; };
  user?: number;
  auth?: string;
  vendor?: string;
  dataAuth?: string;
  datiAnagrafici?: FormGroup;
  datiFornitura?: FormGroup;
  datiPagamento?: FormGroup;
  datiFirma?: FormGroup;
  codAdesione?: string;
  ctr_data?: any; // per precompilare con dati esistenti


  private toponimi$!: Observable<any>;
  private comuni$!: Observable<any>;
  private province$!: Observable<any>;
  private pacchetti$!: Observable<any>;
  private podMaster$!: Observable<any>;
  private fornitori$!: Observable<any>;

  getPacchetti() {
    if (!this.pacchetti$) {
      this.pacchetti$ = this.api.get('get_pacchetti', {
        'tipo_cliente': this.prodotto?.tipo_utenza
      }).pipe(
        tap(),
        shareReplay(1)
      );
    }
    return this.pacchetti$;
  }

  /**
   * Restituisce i POD Master disponibili come riferimento per un POD figlio.
   * Filtrati per auth_user e per ultimo otp_step con stato valido.
   * shareReplay(1): evita chiamate duplicate nella stessa sessione.
   */
  getPodMaster() {
    if (!this.podMaster$) {
      this.podMaster$ = this.api.get('get_pod_master', {
        'userId': this.user
      }).pipe(
        tap(),
        shareReplay(1)
      );
    }
    return this.podMaster$;
  }

  getToponimi() {
    if (!this.toponimi$) {
      this.toponimi$ = this.api.get('getToponimi').pipe(
        tap(),
        shareReplay(1)
      );
    }
    return this.toponimi$;
  }

  getComuni() {
    if (!this.comuni$) {
      this.comuni$ = this.api.get('getComuni').pipe(
        tap(),
        shareReplay(1)
      );
    }
    return this.comuni$;
  }

  getFornitori() {
    if (!this.fornitori$) {
        this.fornitori$ = this.api.get('getFornitori').pipe(
            tap(),
            shareReplay(1)
        );
    }
    return this.fornitori$;
  }

  getProvince() {
    if (!this.province$) {
      this.province$ = this.api.get('getProvince').pipe(
        tap(),
        shareReplay(1)
      );
    }
    return this.province$;
  }

  constructor(
    private api: ApiHttpService
  ) { }

}